import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { EnvironmentProperty } from '../environments/environment.model';

@Injectable()
export class ApiEnvironmentService {
  private environmentProperties: EnvironmentProperty;

  constructor() {
    const envProperties = <EnvironmentProperty>environment;
    this.environmentProperties = envProperties;
    const outsideEnvironmentProperties = <EnvironmentProperty>(<any>window).__env;
    if (outsideEnvironmentProperties) {
      this.environmentProperties = { ...envProperties, ...outsideEnvironmentProperties };
    }
  }

  public getuxDomain(): string {
    return this.environmentProperties.uxDomain;
  }

  public getApiBaseHref(): string {
    return this.environmentProperties.apiDomain;
  }

  public getHome(): string {
    return this.environmentProperties.home;
  }

  public getIsProduction(): boolean {
    return !!this.environmentProperties.production;
  }

  public getIsDevMode(): boolean {
    return this.environmentProperties.isDevMode;
  }

  public getAnalyticsId(): string {
    return this.environmentProperties.analyticsId;
  }

  public getAuthToken(): string {
    return this.environmentProperties.authToken;
  }
}
